var React = require('react');

function IconTickMark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.3709 1.55936C13.7523 1.85604 13.821 2.40578 13.5243 2.78724L5.35767 13.2872C5.20359 13.4853 4.97185 13.6078 4.72136 13.6234C4.47087 13.6389 4.22574 13.5462 4.04827 13.3688L0.548274 9.86876C0.206565 9.52705 0.206565 8.97303 0.548274 8.63132C0.889982 8.28961 1.444 8.28961 1.78571 8.63132L4.58484 11.4304L12.143 1.71284C12.4397 1.33139 12.9894 1.26267 13.3709 1.55936Z","fill":"currentColor"}));
}

IconTickMark.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 14 14","fill":"none"};

module.exports = IconTickMark;

IconTickMark.default = IconTickMark;
